// eslint-disable-next-line import/no-cycle
import { academicdates as schemaAcademicsDates } from './schemas';
import apiClient from './apiClient';
import AcademicDatesDataStore from '../../datastores/AcademicDatesDataStore';

class AcademicCalendarDataStoreGraphQL implements AcademicDatesDataStore {
  async getAcademicDates(period: string) {
    const storedData = localStorage.getItem('academicDates');

    if (storedData && period) {
      return JSON.parse(storedData);
    }

    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaAcademicsDates.getAcademicDates,
        variables: { period },
        fetchPolicy: period ? 'cache-first' : 'no-cache'
      });

      const academicDates = response?.data?.academic?.calendar;
      if (academicDates && period) {
        localStorage.setItem('academicDates', JSON.stringify(academicDates));
      }
      return academicDates;
    } catch (error) {
      throw new Error('error ac-calendar');
    }
  }
}
export default AcademicCalendarDataStoreGraphQL;
